import { useState, useEffect, useRef } from 'react';
import { ClassicEditor, AccessibilityHelp, Alignment, BlockQuote, Essentials, FontBackgroundColor, FontColor, FontFamily, FontSize, ImageToolbar, Indent, IndentBlock, Link, List, Paragraph, SelectAll, SpecialCharacters, Table, TableToolbar, TextTransformation, Undo, EditorConfig, Autoformat, AutoImage, FindAndReplace, FullPage, GeneralHtmlSupport, Heading, HorizontalLine, ImageCaption, ImageInsert, ImageResize, ImageStyle, ImageUpload, LinkImage, MediaEmbed, MediaEmbedToolbar, PasteFromOffice, SpecialCharactersArrows, SpecialCharactersCurrency, SpecialCharactersEssentials, SpecialCharactersLatin, SpecialCharactersMathematical, SpecialCharactersText, WordCount, Image, CodeBlock } from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { HtmlCustomUploadAdapterPlugin } from './UploadAdapterPlugin';

interface IProps {
    htmlData?: string;
    setHtmlData?: Function;
    onChange?: (data: string) => void
    style?: React.CSSProperties;
    className?: string
}
const HtmlCustomEditor = ({ htmlData, setHtmlData, onChange, style, className }: IProps) => {
    const editorContainerRef = useRef(null);
    const editorRef = useRef(null);
    const testRef = useRef(null)
    const [isLayoutReady, setIsLayoutReady] = useState(false);
    const [testHtml, setHtml] = useState('');
    const decodeHtml = (html: string) => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };

    useEffect(() => {
        setIsLayoutReady(true);
        return () => setIsLayoutReady(false);
    }, []);

    const CKEditorComponent = () => {
        const editorConfig: EditorConfig = {
            toolbar: {
                items: ['heading', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', 'alignment', 'fontSize', 'fontColor', 'fontBackgroundColor', 'fontFamily', '|', 'specialCharacters', 'imageInsert', 'mediaEmbed', '|', 'blockQuote', 'insertTable', 'horizontalLine', 'findAndReplace', 'undo', 'redo', 'accessibilityHelp', 'codeBlock'],
            },
            language: 'ko',
            image: {
                toolbar: ['imageTextAlternative', 'toggleImageCaption', 'linkImage', 'imageStyle:inline', 'imageStyle:block', 'imageStyle:side']
            },
            extraPlugins: [HtmlCustomUploadAdapterPlugin],
            mediaEmbed: {
                toolbar: ['mediaEmbed', 'mediaEmbedToolbar'],
                previewsInData: true
            },
            table: {
                contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
            },

            plugins: [AccessibilityHelp, Alignment, AutoImage, Autoformat, BlockQuote, Essentials, FindAndReplace, FontBackgroundColor, FontColor, FontFamily, FontSize, FullPage, GeneralHtmlSupport, Heading, HorizontalLine, Image, ImageCaption, ImageInsert, ImageResize, ImageStyle, ImageToolbar, ImageUpload, Indent, IndentBlock, Link, LinkImage, List, MediaEmbed, MediaEmbedToolbar, Paragraph, PasteFromOffice, SelectAll, SpecialCharacters, SpecialCharactersArrows, SpecialCharactersCurrency, SpecialCharactersEssentials, SpecialCharactersLatin, SpecialCharactersMathematical, SpecialCharactersText, Table, TableToolbar, TextTransformation, Undo, WordCount, CodeBlock],
            fontFamily: { supportAllValues: true },
            fontSize: {
                options: [10, 12, 14, 'default', 18, 20, 22],
                supportAllValues: true
            },
            codeBlock: {
                languages: [
                    { language: 'html', label: 'HTML' },
                    { language: 'javascript', label: 'JavaScript' },
                    { language: 'css', label: 'CSS' }
                ]
            },
        };
        return <>
            <CKEditor editor={ClassicEditor} config={editorConfig} data={htmlData ?? ''} onChange={(event, editor) => { setHtml(editor.getData()); onChange?.(editor.getData()); setHtmlData?.(editor.getData()); }} />
        </>
    };

    return <>
        <div className={"editor-container editor-container_classic-editor " + className} ref={editorContainerRef} style={{ minHeight: '300px', ...style }}>
            <div ref={editorRef}>{isLayoutReady && CKEditorComponent()}</div>
            {/* <div>{testHtml}</div>
            <div>{decodeHtml(testHtml)}</div>
            <div ref={testRef} dangerouslySetInnerHTML={{ __html: decodeHtml(testHtml) }} /> */}
        </div>
    </>
}

export default HtmlCustomEditor 